// Nav scrolled state
  const nav = document.getElementById('nav');
  const setNavState = () => {
    if (window.scrollY > 60) nav.classList.add('is-scrolled');
    else nav.classList.remove('is-scrolled');
  };
  setNavState();
  window.addEventListener('scroll', setNavState, { passive: true });

  // Reveal on scroll
  const io = new IntersectionObserver((entries) => {
    entries.forEach((e) => {
      if (e.isIntersecting) {
        e.target.classList.add('in');
        io.unobserve(e.target);
      }
    });
  }, { threshold: 0.12, rootMargin: '0px 0px -8% 0px' });
  document.querySelectorAll('.reveal, .reveal-stagger').forEach((el) => io.observe(el));

  // Form
  const form = document.getElementById('contact-form');
  const success = document.getElementById('form-success');
  const successName = document.getElementById('success-name');
  const submitBtn = document.getElementById('submit-btn');

  function setError(name, msg) {
    if (!form) return;
    const field = form.elements[name].closest('.field');
    field.classList.toggle('error', !!msg);
    const err = field.querySelector('.err');
    if (err) err.textContent = msg || '';
  }

  if (form) {
    form.addEventListener('submit', async (e) => {
      e.preventDefault();
      const data = Object.fromEntries(new FormData(form));

      let ok = true;
      if (!data.name.trim()) { setError('name', 'A name to greet you by'); ok = false; } else setError('name', '');
      if (!/^\S+@\S+\.\S+$/.test(data.email.trim())) { setError('email', 'A reachable email, please'); ok = false; } else setError('email', '');
      if (data.message.trim().length < 4) { setError('message', 'Even a few words is enough'); ok = false; } else setError('message', '');

      if (!ok) return;

      submitBtn.disabled = true;
      submitBtn.querySelector('span').textContent = 'Sending…';
      await new Promise(r => setTimeout(r, 900));

      successName.textContent = data.name.split(' ')[0];
      form.classList.add('is-sent');
      if (success) success.classList.add('is-on');
    });
  }

  // Testimonial expand
  document.querySelectorAll('.quote').forEach((q) => {
    const p = q.querySelector('p');
    const btn = q.querySelector('.more');
    if (!p || !btn) return;
    // Hide the button if text isn't actually truncated
    requestAnimationFrame(() => {
      if (p.scrollHeight <= p.clientHeight + 2) btn.hidden = true;
    });
    btn.addEventListener('click', () => {
      const open = q.classList.toggle('is-open');
      btn.textContent = open ? 'Read less' : 'Read full';
      btn.setAttribute('aria-expanded', open ? 'true' : 'false');
    });
  });